import script from "./vmsOrgWorkflowManager.vue?vue&type=script&lang=js"
export * from "./vmsOrgWorkflowManager.vue?vue&type=script&lang=js"

import "./vmsOrgWorkflowManager.vue?vue&type=style&index=0&id=27dbbd2d&scoped=true&lang=css"
import "./vmsOrgWorkflowManager.vue?vue&type=style&index=1&id=27dbbd2d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27dbbd2d"]])

export default __exports__